import type { TOC } from '@ember/component/template-only';

interface SettingsHotelAccessFormsAccessRightsHotelNameSignature {
  Args: {
    cellData: string;
    row: {
      isLocked: boolean;
      subscriptionDescription?: string;
    };
  };
}

const SettingsHotelAccessFormsAccessRightsHotelName = <template>
  <div class="hotel-name-cell">
    <p
      class="hotel-name-cell__subscription-name text-200--regular truncate
        {{if @row.isLocked 'row-text--disabled'}}"
    >{{@cellData}}</p>

    {{#if @row.subscriptionDescription}}
      <p
        class="hotel-name-cell__subscription-description text-200--regular truncate
          {{if @row.isLocked 'row-text--disabled'}}"
      >{{@row.subscriptionDescription}}</p>
    {{/if}}
  </div>
</template> satisfies TOC<SettingsHotelAccessFormsAccessRightsHotelNameSignature>;

export default SettingsHotelAccessFormsAccessRightsHotelName;
